import { Component, Injector, Input, OnInit, OnChanges, OnDestroy, ElementRef, Output, EventEmitter, HostListener, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TBSBaseComponent } from '../../../shared/models/tbsBaseComponent';
import { ChatMessage } from '../../../shared/models/chatMessage.model';
import { takeUntil } from 'rxjs';
import { AiChatService } from '../ai-chat.service';
import { SaveResult } from 'src/app/shared/models/libraryItem.model';
import { SharedModule } from 'src/app/shared/shared.module';
import { AiDynamicTemplateComponent } from 'src/app/modules/ai-chat/ai-dynamic-template/ai-dynamic-template.component';

@Component({
  selector: 'app-chat-tile',
  templateUrl: './chat-tile.component.html',
  standalone: true,
  imports: [CommonModule, SharedModule, AiDynamicTemplateComponent]
})
export class ChatTileComponent extends TBSBaseComponent implements OnInit, OnChanges, OnDestroy {
  @Input() chatMessage: ChatMessage;
  @Input() isNiceChatEnabled: boolean = false;
  @Input() autoFocus: boolean = false;
  @Output() launchLiveChat = new EventEmitter<void>();
  @Output() navigateToHelp = new EventEmitter<void>();
  @Output() showLiveChatPrompt = new EventEmitter<string>();
  
  ThumbsUp: boolean = false;
  ThumbsDown: boolean = false;
  saveResult: SaveResult;
  chatid:string;
  showDynamicForm: boolean;

  constructor(injector: Injector, private readonly elementRef: ElementRef, private readonly chatService: AiChatService) {
    super(injector);
    this.addResourceStringKeys([
      'Aon.Ai.ChatTileFeedback',
      'Aon.Ai.Panel.ThinkingIndicator',
      'Aon.AI.Aria.label.Selected',
      'Aon.AI.Aria.label.notSelected',
      'Aon.AI.Chat.OpenLiveChat.ButtonText',
      'Aon.AI.Chat.Like',
      'Aon.AI.Chat.Dislike',
      'Aon.AI.Chat.Panel.AssistantName'
    ]);
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    // Focus the thumbs-up when a new response arrives.
    // firstChange guard prevents focus moving on panel open with existing messages.
    if (changes['autoFocus']?.currentValue === true && !changes['autoFocus'].firstChange) {
      setTimeout(() => {
        (this.elementRef.nativeElement.querySelector('.fa-thumbs-up') as HTMLElement)?.focus();
      }, 100);
    }
  }

  ngOnInit(): void {
    this.loadResourceStringAsObservable()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        this.getResouceStringsAsObject(res);
      });
  }

  ngOnDestroy(): void {
    this.signalUnsubscribe();
  }

  get isSender(): boolean {
    return this.chatMessage.type === 'sender';
  }

  protected resolveUserName(name: string): string {
    if (name === 'Aon.AI.Chat.Panel.AssistantName') {
      return this.resourceStrings['Aon.AI.Chat.Panel.AssistantName'];
    }
    return name;
  }

  toggleThumbsUp() {
    let questionID = this.chatMessage.questionID
    this.ThumbsUp = !this.ThumbsUp
    if(this.ThumbsUp){
      this.ThumbsDown = false
      this.sendVoteIsLike( 2 , questionID)
    }
    else{
      this.sendVoteIsLike( 0 , questionID)
    }
  }

  toggleThumbsDown() {
    let questionID = this.chatMessage.questionID
    this.ThumbsDown = !this.ThumbsDown
    if(this.ThumbsDown){
      this.ThumbsUp = false
      this.sendVoteIsLike(1, questionID)
      // Emit event to show live chat prompt when user gives negative feedback
      this.showLiveChatPrompt.emit(questionID);
    }
    else{
      this.sendVoteIsLike(0, questionID)
    }
  }

  sendVoteIsLike(sendFeedback: number, questionID:string ) {
    this.chatService.sendFeedback(sendFeedback, questionID).subscribe()
  }

  onLaunchLiveChat(): void {
    this.launchLiveChat.emit();
  }

  @HostListener('click', ['$event']) // In Angular 21, stricter type checking requires that the event type in your handler matches the event type emitted by @HostListener.
  onMessageClick(event: MouseEvent): void {
    this.handleMessageEvent(event);
  }

  @HostListener('keydown.enter', ['$event']) // In Angular 21, stricter type checking requires that the event type in your handler matches the event type emitted by @HostListener.
  onMessageKeydown(event: Event): void {
    this.handleMessageEvent(event as KeyboardEvent);
  }

  private handleMessageEvent(event: MouseEvent | KeyboardEvent): void {
    const target = event.target as HTMLElement;
    // Check if clicked element is an anchor tag with specific data attribute
    if (target.tagName === 'A' && target.getAttribute('data-nav') === 'help') {
      event.preventDefault();
      this.navigateToHelp.emit();
    }
  }

}
